import {
  PersonProfileImageQualityResponse,
  PersonProfileImageType,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useCheckPersonProfileImageQuality(
  imageType: PersonProfileImageType = 'primary'
) {
  const url = `/v2/orm/person_profile/check_image_quality?imageType=${imageType}`;

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<PersonProfileImageQualityResponse, FormData>(
    request,
    {
      getBody: (formData) => {
        const newFormData = new FormData();
        const file = formData.get('file');
        if (file) {
          newFormData.append('profileImage', file);
        }
        const firstName = formData.get('firstName');
        if (firstName) {
          newFormData.append('firstName', firstName);
        }
        const lastName = formData.get('lastName');
        if (lastName) {
          newFormData.append('lastName', lastName);
        }
        return newFormData;
      },
      responseModifier: async (response) => {
        const respJson = await response.json();
        return respJson as PersonProfileImageQualityResponse;
      },
    }
  );
}

export default useCheckPersonProfileImageQuality;
